import {DataGrid} from "@mui/x-data-grid";
import {useGetPurchaseItemsMCQuery, useGetSpendItemsMCQuery} from "../../../core/api/mc-analytical-data-api";
import Loading from "../../../components/Common/Loading";

const columns = [
    { label: 'id', field: 'id', flex: 1 },
    { label: 'globalLevel', field: 'globalLevel', flex: 1 },
    { label: 'globalHard', field: 'globalHard', flex: 1 },
    { label: 'globalLives', field: 'globalLives', flex: 1 },
    { label: 'globalAdSegment', field: 'globalAdSegment', flex: 1 },
    { label: 'type', field: 'type', flex: 1 },
    { label: 'item', field: 'item', flex: 1 },
    { label: 'itemName', field: 'itemName', flex: 1 },
    { label: 'amount', field: 'amount', flex: 1 },
    { label: 'source', field: 'source', flex: 1 },
    { label: 'sessionVersion', field: 'sessionVersion', flex: 1 },
    { label: 'timestamp', field: 'timestamp', flex: 1 },

]

const PurchaseMC = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPurchaseItemsMCQuery({
        userId: props.deviceId,
        limit: 100,
        page: 0
    })

    let payments = ""

    if (typeof data === "object") {

        payments = <DataGrid
            getRowId={(row) => row.id}
            rows={data}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[100]}
            autoHeight

        />
    } else {
        payments = "no data"
    }

    return (
        <Loading
            isLoading={isLoading||isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {payments}

        </Loading>
    )
}

export default PurchaseMC